export const SAVE_CARD = 'save_card'
export const GET_CARD_REQUEST = 'get_card_request'
export const GET_CARD_RESPONSE = 'get_card_response'
export const CARD_ERROR = 'card_error'
